<div class="flex items-center justify-center p-8 bg-gray-100">
  <div class="bg-white rounded-2xl shadow-lg p-8 text-center max-w-md">
    <!-- Icona spunta verde -->
    <div class="flex items-center justify-center w-20 h-20 mx-auto rounded-full bg-green-100 mb-6">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>

    <!-- Messaggio -->
    <h1 class="text-2xl font-bold text-gray-800 mb-2">Pagamento completato!</h1>
    <p class="text-gray-600">Grazie per il tuo acquisto. La transazione è andata a buon fine.</p>

  </div>
</div>

